/**
 * US customary display helpers. Scene / lot storage stays meters.
 * See docs/XLABS_LOCATE.md
 */

export const M_TO_FT = 3.280839895;
export const FT_TO_M = 1 / M_TO_FT;
export const M2_TO_SQFT = M_TO_FT * M_TO_FT;

export function mToFt(m) {
  return (Number(m) || 0) * M_TO_FT;
}

export function ftToM(ft) {
  return (Number(ft) || 0) * FT_TO_M;
}

export function m2ToSqFt(m2) {
  return (Number(m2) || 0) * M2_TO_SQFT;
}

export function formatFt(m, digits = 1) {
  return `${mToFt(m).toFixed(digits)} ft`;
}

export function formatSqFt(m2, digits = 0) {
  return `${m2ToSqFt(m2).toFixed(digits)} sq ft`;
}

/** Snap chip sizes in feet (stored as meters in state). */
export const SNAP_FT_OPTIONS = [0.5, 1, 2];

export function snapFtMatches(sizeM, ft) {
  return Math.abs(mToFt(sizeM) - ft) < 0.05;
}
